import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { HashRouter, Route } from 'react-router-dom';
import Platform from 'platform';

import { GA_CONTAINER_ID, GTM_CONTAINER_ID, GTM_OPTIMIZE_ID } from '../config';

import LeavePageConfirmationModal from '../components/LeavePageConfirmationModal';
import GoogleTagManager from '../components/GoogleTagManager';
import PageWrapper from './PageWrapper';
import { getBrowserInfo, isSupportedBrowser } from '../lib/UserAgentUtils';
import pageHiding from '../lib/pageHiding';
import { version } from '../../package.json';
import { Footer, UnsupportedBrowser } from 'z-react-components';

export default class Root extends Component {
    constructor(props) {
        super(props);
        if (GA_CONTAINER_ID && GTM_OPTIMIZE_ID) {
            pageHiding(GTM_OPTIMIZE_ID);
        }
    }

    render() {
        const getConfirmation = (message, callback) => {
            ReactDOM.render(
                <LeavePageConfirmationModal
                    message={{
                        content: message.split('|')[0],
                        remainButtonMessage: message.split('|')[1]
                    }}
                    onClick={callback}
                />,
                document.getElementById('leave-page-modal')
            );
        };
        return (
            <HashRouter getUserConfirmation={getConfirmation}>
                {isSupportedBrowser() ? (
                    <div>
                        {GTM_CONTAINER_ID ? <GoogleTagManager /> : null}
                        <Route render={props => <PageWrapper pathname={props.location.pathname} history={props.history} />} />
                    </div>
                ) : (
                    <div>
                        <UnsupportedBrowser browserInfo={getBrowserInfo(Platform.name)} />
                        <Footer version={version} />
                    </div>
                )}
            </HashRouter>
        );
    }
}
